
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class TipologieEsperienzeGrid extends Serenity.EntityGrid<TipologieEsperienzeRow, any> {
        protected getColumnsKey() { return TipologieEsperienzeColumns.columnsKey; }
        protected getDialogType() { return TipologieEsperienzeDialog; }
        protected getIdProperty() { return TipologieEsperienzeRow.idProperty; }
        protected getInsertPermission() { return TipologieEsperienzeRow.insertPermission; }
        protected getLocalTextPrefix() { return TipologieEsperienzeRow.localTextPrefix; }
        protected getService() { return TipologieEsperienzeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}